export const dashboardTypes = [
  {name: "Individual view", value: "individual"},
  {name: "Team view", value: "team"}
];
